import React from "react";
import {
  Box,
  Typography,
  Grid,
  Stack,
  IconButton,
  Tooltip,
  Chip,
} from "@mui/material";
import {
  ExpandMoreRounded as ExpandMoreIcon,
  SettingsPowerRounded as PowerIcon,
  DnsRounded as DnsIcon,
  EditRounded as EditIcon,
} from "@mui/icons-material";
import MiniMetric from "../MiniMetric"; // MiniMetric bileşeninin yoluna dikkat et

export default function ServerRowHeader({
  server,
  stats,
  isExpanded,
  setIsExpanded,
  isOffline,
  isPending,
  ddosAlert,
  onEdit,
}) {
  const getProgressColor = (value) => {
    if (value >= 90) return "error";
    if (value >= 75) return "warning";
    return "primary";
  };

  return (
    <Box
      onClick={() => setIsExpanded(!isExpanded)}
      sx={{
        p: { xs: 2.5, sm: 3.5 },
        cursor: "pointer",
        display: "flex",
        flexDirection: { xs: "column", lg: "row" },
        alignItems: { xs: "flex-start", lg: "center" },
        gap: 4,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2.5,
          width: { xs: "100%", lg: "25%" },
          flexShrink: 0,
        }}
      >
        <Box sx={{ position: "relative", display: "flex" }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              bgcolor: isOffline ? "text.disabled" : "success.main",
              boxShadow: isOffline ? "none" : "0 0 12px #3ddc97",
              zIndex: 2,
            }}
          />
          {!isOffline && !isPending && (
            <Box
              sx={{
                position: "absolute",
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                bgcolor: "success.main",
                animation: "ping 2s cubic-bezier(0, 0, 0.2, 1) infinite",
                "@keyframes ping": {
                  "75%, 100%": { transform: "scale(3)", opacity: 0 },
                },
              }}
            />
          )}
        </Box>
        <Box>
          <Typography sx={{ fontWeight: "800", letterSpacing: "-0.5px" }}
            variant="h6"
          >
            {server.name}
          </Typography>
          <Stack sx={{ alignItems: "center" }} direction="row" spacing={1}>
            <DnsIcon sx={{ fontSize: 12, color: "text.secondary" }} />
            <Typography sx={{ color: "text.secondary", fontFamily: "monospace", fontSize: "0.8rem" }}
              variant="body2"
            >
              {server.ip_address}
            </Typography>
          </Stack>
          {!isPending && (
            <Typography
              variant="caption"
              sx={{
                color: "primary.light",
                mt: 1,
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                fontWeight: 600,
              }}
            >
              <PowerIcon sx={{ fontSize: 14 }} /> {stats.uptime}
            </Typography>
          )}
        </Box>
      </Box>

      {/* 25% + 60% + 15% ve aradaki 2 boşluk satırı taşırıyordu; DDoS etiketi ağ değerinin üstüne biniyordu.
          Ölçümler kalan alanı alır, düğmeler kendi genişliğinde kalır. */}
      <Grid container spacing={3} sx={{ width: { xs: "100%", lg: "auto" }, flex: { lg: 1 }, minWidth: 0 }}>
        <Grid size={{ xs: 6, sm: 3 }}>
          <MiniMetric
            title="CPU"
            val={`%${stats.cpu_percent.toFixed(1)}`}
            prog={stats.cpu_percent}
            col={getProgressColor(stats.cpu_percent)}
          />
        </Grid>
        <Grid size={{ xs: 6, sm: 3 }}>
          <MiniMetric
            title="RAM"
            val={`%${stats.ram_percent.toFixed(1)}`}
            prog={stats.ram_percent}
            col={getProgressColor(stats.ram_percent)}
          />
        </Grid>
        <Grid size={{ xs: 6, sm: 3 }}>
          <MiniMetric
            title="DİSK"
            val={`%${stats.disk_percent.toFixed(1)}`}
            prog={stats.disk_percent}
            col={getProgressColor(stats.disk_percent)}
          />
        </Grid>
        <Grid size={{ xs: 6, sm: 3 }}>
          <MiniMetric
            title="AĞ (KB/s)"
            val={stats.net_rx}
            prog={100}
            col="secondary"
          />
        </Grid>
      </Grid>

      <Box
        sx={{
          width: { xs: "100%", lg: "auto" },
          flexShrink: 0,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        {ddosAlert && (
          <Tooltip title="Sıradışı Trafik Algılandı">
            <Chip
              label="DDoS Risk"
              color="error"
              size="small"
              sx={{ fontWeight: "bold", animation: "pulse 1.5s infinite" }}
            />
          </Tooltip>
        )}

        {/* YENİ EKLENEN: Düzenle Butonu */}
        <Tooltip title="Sunucuyu Düzenle">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }} // Tıklayınca akordeon açılmasın diye stopPropagation
            sx={{
              color: "secondary.main",
              bgcolor: "rgba(45,167,255,0.1)",
              "&:hover": { bgcolor: "rgba(45,167,255,0.2)" },
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        <IconButton
          sx={{
            transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "0.4s",
            color: isExpanded ? "primary.main" : "text.secondary",
            bgcolor: isExpanded ? "rgba(29, 111, 242, 0.1)" : "transparent",
          }}
        >
          <ExpandMoreIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
